import { render, staticRenderFns } from "./公司荣誉.vue?vue&type=template&id=36cc03fc&scoped=true&"
import script from "./公司荣誉.vue?vue&type=script&lang=js&"
export * from "./公司荣誉.vue?vue&type=script&lang=js&"
import style0 from "./公司荣誉.vue?vue&type=style&index=0&id=36cc03fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cc03fc",
  null
  
)

export default component.exports